
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter } from 'vuex-class'

@Component({})
export default class AssetDevices extends Mixins(TranslationHandler) {
  @Getter visualPrimaryColor!: string
  @Getter visualTextColor!: string
  @Getter visualIsDark!: boolean

  get stroke(): string {
    return this.visualIsDark ? '#C4C4C4' : '#263451'
  }
}
